/**
 * Accessibility wrapper for a loading area. Marks its subtree as a single `role="status"` live region
 * with `aria-busy`, so a screen reader announces the `label` once while the content loads. The
 * skeletons (or spinner) it wraps stay decorative — accessibility is owned here, by the region, not by
 * each placeholder. Use one per suspended area, never one per skeleton.
 *
 * `label` is required so the localized string is supplied by the consumer; the design system ships no
 * hard-coded copy.
 *
 * @summary Live region announcing a loading area (`role="status"` + `aria-busy`).
 */
function LoadingRegion({ label, ...rest }: LoadingRegion.Props) {
  return <div {...rest} role="status" aria-busy="true" aria-label={label} data-slot="loading-region" />
}
namespace LoadingRegion {
  export type Props = React.ComponentProps<'div'> & {
    /** Localized loading message announced to assistive tech (e.g. "Chargement"). */
    label: string
  }
}

export { LoadingRegion }
